import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'text';
  children: React.ReactNode;
  icon?: boolean;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  icon = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-aspect-black focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-aspect-black text-aspect-white hover:bg-aspect-black/90 h-10 px-6 py-2',
    secondary: 'border border-aspect-gray text-aspect-black hover:bg-aspect-gray/10 h-10 px-6 py-2',
    text: 'text-aspect-black hover:text-aspect-gray underline-offset-4 hover:underline p-0 h-auto'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-42">
      {children}
      {icon && <ArrowRight className="ml-2 h-4 w-4" data-id="element-43" />}
    </button>;
}